import { API_BASE_URL, API_ENDPOINTS } from '../../constants/api';
import { apiFetch } from '../../utils/apiClient';

const withBaseUrl = (endpoint) => `${API_BASE_URL}${endpoint}`;

export const fetchPdfWorkflowState = async ({ pdfId, sectionNumber = null } = {}) => {
  const normalizedPdfId = String(pdfId || '').trim();
  if (!normalizedPdfId) {
    throw new Error('PDF ID is required');
  }

  const normalizedSectionNumber = Number(sectionNumber);
  const hasSection =
    Number.isFinite(normalizedSectionNumber) && normalizedSectionNumber > 0;

  const endpoint = hasSection
    ? API_ENDPOINTS.PDF_SECTION_WORKFLOW_STATE(normalizedPdfId, normalizedSectionNumber)
    : API_ENDPOINTS.PDF_WORKFLOW_STATE(normalizedPdfId);

  const response = await apiFetch(withBaseUrl(endpoint));
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || 'Failed to load workflow state');
  }

  return response.json();
};
